import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Map } from 'immutable';
import { Flex, Box } from 'grid-styled';
import { setViewstate } from '../actions/actionCreators';
import connect from '../store/connect';
import { FilterOption } from '../styles/FilterOption';

class SortingList extends Component {
  setSortBy(key, ascending) {
    this.props.setViewstate('sortBy', key);
    this.props.setViewstate('sortAscending', ascending);
  }

  render() {
    const { width, margin, marginBottom, includeRelevance } = this.props;

    return (
      <FullWidthFlex flexWrap="wrap" mb={marginBottom}>
        {includeRelevance ? (
          <Box width={width} px={margin}>
            <FilterOption
              radioButton
              active={this.props.viewstate.get('sortBy') === 'relevance' && this.props.viewstate.get('sortAscending')}
              onClick={() => this.setSortBy('relevance', true)}
            >
              Sökrelevans
            </FilterOption>
          </Box>
        ) : (
          false
        )}
        <Box width={width} px={margin}>
          <FilterOption
            radioButton
            active={this.props.viewstate.get('sortBy') === 'name' && !this.props.viewstate.get('sortAscending')}
            onClick={() => this.setSortBy('name', false)}
          >
            Namn (A-Ö)
          </FilterOption>
        </Box>
        <Box width={width} px={margin}>
          <FilterOption
            radioButton
            active={this.props.viewstate.get('sortBy') === 'name' && this.props.viewstate.get('sortAscending')}
            onClick={() => this.setSortBy('name', true)}
          >
            Namn (Ö-A)
          </FilterOption>
        </Box>
        <Box width={width} px={margin}>
          <FilterOption
            radioButton
            active={this.props.viewstate.get('sortBy') === 'price' && !this.props.viewstate.get('sortAscending')}
            onClick={() => this.setSortBy('price', false)}
          >
            Pris lågt till högt
          </FilterOption>
        </Box>
        <Box width={width} px={margin}>
          <FilterOption
            radioButton
            active={this.props.viewstate.get('sortBy') === 'price' && this.props.viewstate.get('sortAscending')}
            onClick={() => this.setSortBy('price', true)}
          >
            Pris högt till lågt
          </FilterOption>
        </Box>
        <Box width={width} px={margin}>
          <FilterOption
            radioButton
            active={this.props.viewstate.get('sortBy') === 'addedDate' && this.props.viewstate.get('sortAscending')}
            onClick={() => this.setSortBy('addedDate', true)}
          >
            Senast inkommet
          </FilterOption>
        </Box>
      </FullWidthFlex>
    );
  }
}

const FullWidthFlex = styled(Flex)`
  width: 100%;
`;

SortingList.defaultProps = {
  viewstate: Map(),
  margin: 40,
  marginBottom: 0,
  width: [1, 1 / 2, 1 / 3, 1 / 4],
  includeRelevance: false
};

SortingList.propTypes = {
  setViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  margin: PropTypes.number,
  marginBottom: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  includeRelevance: PropTypes.bool
};

export default connect(
  SortingList,
  { setViewstate },
  store => ({
    viewstate: store.viewstate
  })
);



// WEBPACK FOOTER //
// ./src/components/SortingList.js